import styled from 'styled-components';
import { BG_IMG } from '../../config/constants';

const Wrapper = styled.div`
	width: 100%;
	height: 100vh;
	/* background-image: url(${BG_IMG}); */
	background-size: cover;
	background-position: center;
	h2 {
		font-family: HaasGrotDisp, -apple-system, system-ui;
		font-weight: bold;
		font-size: 24px;
		text-align: center;
		margin-bottom: 22px;
	}

	.form-box {
		width: 425px;
		height: auto;
		box-sizing: border-box;
		background-color: #fff;
		padding: 20px;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 5px;
		box-shadow: 1px 1px 3px 3px rgba(50, 50, 50, 0.1);

		.btn-area {
			margin-top: 12px;
			> * {
				margin: 0 2px;
			}
		}
	}
`;

export default Wrapper;
